// /* eslint-disable no-console */
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import { BrowserRouter } from 'react-router-dom';
// import { PublicClientApplication, EventType } from '@azure/msal-browser';
// import { Provider } from 'react-redux';
// import App from './App';
// import store from './utils/store';
// import { msalConfig } from './auth.config';

// const msalInstance = new PublicClientApplication(msalConfig);
// await msalInstance.initialize();
// await msalInstance.handleRedirectPromise();
// // // Default to using the first account if no account is active on page load
// if (
// 	!msalInstance.getActiveAccount() &&
// 	msalInstance.getAllAccounts().length > 0
// ) {
// 	// Account selection logic is app dependent. Adjust as needed for different use cases.
// 	msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
// }
// msalInstance.addEventCallback((event) => {
// 	if (
// 		(event.eventType === EventType.LOGIN_SUCCESS ||
// 			event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
// 			event.eventType === EventType.SSO_SILENT_SUCCESS) &&
// 		event.payload.account
// 	) {
// 		msalInstance.setActiveAccount(event.payload.account);
// 	}
// });

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
// 	<BrowserRouter>
// 		<Provider store={store}>
// 			<App instance={msalInstance} />
// 		</Provider>
// 	</BrowserRouter>
// );





/* eslint-disable no-console */
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { Provider } from 'react-redux';
import App from './App';
import store from './utils/store';
import { msalConfig } from './auth.config';

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize and handle authentication
async function initApp() {
  try {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();

    // Set active account if available
    if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
      msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }

    // Listen for MSAL events
    msalInstance.addEventCallback((event) => {
      if (
        (event.eventType === EventType.LOGIN_SUCCESS ||
          event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
          event.eventType === EventType.SSO_SILENT_SUCCESS) &&
        event.payload.account
      ) {
        msalInstance.setActiveAccount(event.payload.account);
      }
    });

    // Render main app
    renderApp();
  } catch (error) {
    console.error('MSAL initialization failed:', error);
    renderAccessDenied(error);
  }
}

// Render main application
function renderApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <BrowserRouter>
      <Provider store={store}>
        <App instance={msalInstance} />
      </Provider>
    </BrowserRouter>
  );
}

// Render Access Denied page
function renderAccessDenied(error) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <div style={{ textAlign: 'center', marginTop: '50px', fontFamily: 'Arial' }}>
      <h1>Access Denied</h1>
      <p>Unable to initialize authentication. Please contact support.</p>
      {error && (
        <p style={{ color: 'gray', fontSize: '14px' }}>
          Error: {error.message || 'Authentication failed'}
        </p>
      )}
    </div>
  );
}

// Start initialization
initApp();